import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const StudentNotes = lazyRouteComponent(() => import('@/_instructor/customer-profile/notes'));

export const Route = createFileRoute('/_instructor/student/notes/')({
  component: () => renderInstructorPage(StudentNotes),
});
